import { render, staticRenderFns } from "./MonthRecord.vue?vue&type=template&id=36026e46&scoped=true&"
import script from "./MonthRecord.vue?vue&type=script&lang=js&"
export * from "./MonthRecord.vue?vue&type=script&lang=js&"
import style0 from "./MonthRecord.vue?vue&type=style&index=0&id=36026e46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36026e46",
  null
  
)

export default component.exports